import { defaultAxios, IParams } from './base';

export interface IPutLoanPreRequest extends IParams {
  // condition 없음
}

export const putLoanPreRequest = (params: IPutLoanPreRequest) => {
  return defaultAxios().put(`/loan/preReq`, params);
};
